import AbstractRequestTask from '../AbstractRequestTask';
import { setProfileLastTouch } from '../../../utils/Socialization';

class AddSocialRelationTask extends AbstractRequestTask {
  constructor(config, urlParams, postParams) {
    super();
    this.config = config;
    this.params = postParams;
    this.urlParams = urlParams;
  }

  getUrl() {
    const domain = this.config.url_dominio_microfwk;

    const params = super.getParams(this.config);
    this.urlParams = Object.assign(params, this.urlParams);

    const getParams = Object.keys(this.urlParams)
      .map(i => `${i}=${this.urlParams[i]}`)
      .join('&');

    return `${domain}services/user/addsocialrelation?${getParams}`;
  }

  getMethod() {
    return 'POST';
  }

  getParams() {
    return { extra_data: this.params };
  }

  success(data, b) {
    const isValid = super.success(data, b);
    if (!isValid) {
      const newData = super.parseErrors(data);
      return this.reject(newData, b);
    }
    if (
      data &&
      data.response &&
      data.response.lasttouch &&
      data.response.lasttouch.profile
    )
      setProfileLastTouch(data.response.lasttouch.profile);
    this.resolve(data);
  }
}

export default AddSocialRelationTask;
